import { observer } from 'mobx-react-lite';
import {
  Card,
  CardActionArea,
  CardContent,
  Typography,
} from '@mui/material';
import type { FileNode } from '../../../../types/admin/nodes';
import './FileCard.scss';
import { useStores } from 'index';

type Props = {
  file: FileNode;
};

export const FileCard = observer(({ file }: Props) => {
  const {
    selectedIds,
    select,
    appendSelection,
    selectRangeTo,
    chooseFile,
  } = useStores().mediaLibraryStore;

  const isSelected = selectedIds.has(file.id);

  const handleClick = (e: React.MouseEvent) => {
    if (e.shiftKey) {
      selectRangeTo(file.id);
    } else if (e.metaKey || e.ctrlKey) {
      appendSelection(file.id);
    } else {
      select([file.id]);
    }
  };

  const handleDoubleClick = () => chooseFile(file.id);

  return (
    <Card
      className={`file-card ${isSelected ? 'file-card--selected' : ''}`}
      onClick={handleClick}
      onDoubleClick={handleDoubleClick}
    >
      <CardActionArea>
        <div className="file-card__preview">
          <img
            src={file.url}
            alt={file.name}
            className="file-card__image"
          />
        </div>
        <CardContent className="file-card__content">
          <Typography
            variant="body2"
            noWrap
            textAlign="center"
            title={file.name}
          >
            {file.name}
          </Typography>
        </CardContent>
      </CardActionArea>
    </Card>
  );
});
